<script lang="ts">
	import DeviceDrawer from './DeviceDrawer.svelte';
	import RoomDrawer from './RoomDrawer.svelte';
	import GroupDrawer from './GroupDrawer.svelte';
	import DefaultDrawer from './DefaultDrawer.svelte';
	import SceneDrawer from './SceneDrawer.svelte';
	import AlarmDrawer from './AlarmDrawer.svelte';
	import { drawerState } from 'src/stores/ui/sidepanel-public';
	import ThermostatDrawer from './ThermostatDrawer.svelte';

	const drawerComponentsMap = {
		room: RoomDrawer,
		device: DeviceDrawer,
		group: GroupDrawer,
		scene: SceneDrawer,
		alarm: AlarmDrawer,
		thermostat: ThermostatDrawer,
	};

	$: drawerComponent =
		'undefined' !== typeof drawerComponentsMap[$drawerState.type]
			? drawerComponentsMap[$drawerState.type]
			: DefaultDrawer;
</script>

{#key $drawerState}
	<svelte:component this={drawerComponent} />
{/key}
